<template>
  <b-modal
    ref="modalUnprintedOrder"
    body-class="!p-10 text-black w-full"
    size="md"
    centered
    hide-footer
    hide-header
  >
    <img
      src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
      alt="warning-bulk-upload"
      class="size-[100px] mx-auto"
    >
    <div
      class="mt-2 text-center"
    >
      <h3 class="text-2xl font-semibold text-black">
        Peringatan
      </h3>
      <p class="font-light mt-[10px] mb-[30px]">
        Ada order yang resinya belum diprint. Harap periksa kembali:
      </p>
      <div class="flex flex-col gap-[12px] max-h-[200px] overflow-y-auto w-full items-center mb-[20px] custom-scrollbar">
        <marketplace-platform-cell
          v-for="(item, index) in data"
          :key="index"
          :platform="item.marketplace"
          :order-number="item.marketplace_order_id"
          class="border-[1px] border-[#E2E2E2] rounded-[8px] w-full justify-center"
        />
      </div>
      <b-button
        variant="primary"
        class="w-full"
        @click="handleCloseModal"
      >Tutup</b-button>
    </div>
  </b-modal>
</template>

<script>
/**
 * @component ModalUnPrintedOrder
 * @description Displays a warning modal for marketplace orders with unprinted receipts.
 *
 * @example
 * <ModalUnPrintedOrder ref="modalUnprintedOrder" />
 * this.$refs.modalUnprintedOrder.show({ data: unprintedOrders })
 */
import MarketplacePlatformCell from './MarketplacePlatformCell.vue'

export default {
  components: {
    MarketplacePlatformCell,
  },
  data() {
    return {
      data: [],
    }
  },
  methods: {
    show({
      data,
    }) {
      this.data = data
      this.$refs.modalUnprintedOrder.show()
    },
    hide() {
      this.$refs.modalUnprintedOrder.hide()
    },
    handleCloseModal() {
      this.hide()
    },
  },
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 8px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
